//----------------------------------------------------------------------------------------------------
// 목차
//----------------------------------------------------------------------------------------------------
import Common from '../common/CommonPowerbook';

class TableOfContents {

    constructor() {
        this.comm = Common.instance;
    }

     make(_d, _idx){
         if(_d.bodys.length<4 || _idx!==0) return '';

         let list = _d.bodys.map( (item, idx) =>{
             if(idx===0) return '';
             return `<li><a href="#${_d.no}-${idx}">${item.header}</a></li>`;
         } ).join('\n ');

         return `
<section class="wiki__index">
    <header class="wiki__index__handler" id="wiki__index__handler">목차<i></i></header>
    <article class="wiki__index__list" id="wiki__index__list">
        <ul>${list}</ul>
    </article>
</section>`;
     }


}


export default TableOfContents;




// WEBPACK FOOTER //
// ./lineage/TableOfContents.js